module.exports = __webpack_public_path__ + "static/submit-success.13bba86b.png";